import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { PortalReferralListItemNode } from '@app/services/api/api.types';
import {
  buildReferralTimeline,
  ReferralTimelineStep,
} from '@app/services/referral-program/referral-detail-timeline.util';
import { showDaysLeftToBook } from '@app/services/referral-program/referrals-page.util';
import {
  REFERRAL_DETAIL_CHECKMARK_ICON,
  REFERRAL_DETAIL_CLOCK_ICON,
  REFERRAL_DETAIL_FAILED_ICON,
} from '@app/utils/referral-assets';

@Component({
  selector: 'referral-detail-modal',
  templateUrl: './referral-detail-modal.component.html',
  styleUrls: ['./referral-detail-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralDetailModalComponent {
  @Input({ required: true }) referral!: PortalReferralListItemNode;

  @Output() close = new EventEmitter<void>();

  showDaysLeftToBook = showDaysLeftToBook;

  REFERRAL_DETAIL_CHECKMARK_ICON = REFERRAL_DETAIL_CHECKMARK_ICON;
  REFERRAL_DETAIL_CLOCK_ICON = REFERRAL_DETAIL_CLOCK_ICON;
  REFERRAL_DETAIL_FAILED_ICON = REFERRAL_DETAIL_FAILED_ICON;

  get timeline(): ReferralTimelineStep[] {
    return buildReferralTimeline(this.referral.displayStatus);
  }
}
